import { values } from "@/mocks/about";

export default function ValuesSection() {
  return (
    <section className="py-20 max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="mb-14">
        <div className="text-[#00ff88] text-xs tracking-[0.3em] uppercase font-semibold mb-4 font-inter">Core Values</div>
        <h2 className="text-4xl lg:text-5xl font-black text-white tracking-tight font-syne">What Drives Us</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {values.map((v, i) => (
          <div key={i} className="p-8 bg-[#0f0f0f] border border-white/5 rounded-sm hover:border-[#00ff88]/20 transition-all group">
            <div className="w-11 h-11 flex items-center justify-center rounded-sm bg-[#00ff88]/10 border border-[#00ff88]/20 mb-6 group-hover:bg-[#00ff88]/15 transition-all">
              <i className={`${v.icon} text-[#00ff88] text-lg leading-none`} />
            </div>
            <h3 className="text-white font-bold text-base mb-3 font-syne">{v.title}</h3>
            <p className="text-white/40 text-sm leading-relaxed font-inter">{v.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
